import { PARTY } from "../data/content";

export function Party() {
  return (
    <section id="party" className="section">
      <div className="container container--1200">
        <div className="section-head">
          <p className="eyebrow">Wedding Party</p>
          <h2 className="h2">The people beside us</h2>
        </div>

        <div className="party__rail">
          <div className="party__rule" aria-hidden="true" />
          <div className="party__grid">
            {PARTY.map((member) => (
              <div className="party__member" key={member.name}>
                {/* TODO: replace with each member's portrait. */}
                <div className="placeholder placeholder--round party__portrait">
                  <span className="mono-caption" style={{ fontSize: 10 }}>
                    Portrait
                  </span>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "var(--s1)" }}>
                  <p className="party__name">{member.name}</p>
                  <p className="eyebrow">{member.role}</p>
                  <p className="party__note">{member.note}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
